import styled from 'styled-components';

const NewsItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 500px;
  box-shadow: 0px 2px 4px rgba(56, 20, 81, 0.15);
  margin-bottom: 20px;
`;

const NewsBody = styled.div`
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  padding: 12px;
  min-height: 93px;
  position: relative;
`;

const NewsBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-bottom: 12px;
  h2 {
    color: #381451;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
  }
  h3 {
    color: #381451;
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }
  p {
    color: #7c6c8a;
    font-size: 14px;
    line-height: 16px;
  }
  a {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-decoration-line: underline;
    color: #e92070;
  }
  b {
    font-weight: 700;
  }
  i {
    font-style: italic;
  }
`;

const NewsBodyHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 15px;
  align-content: center;
  div {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-content: center;
  }
`;

const NewsBodyHeaderLeftContent = styled.div`
  justify-content: flex-start;
  h3 {
    font-size: 13px;
    color: #7c6c8a;
    margin-left: 5px;
  }
`;

const NewsBodyHeaderRightContent = styled.div`
  justify-content: flex-end;
  h4 {
    color: #b3a6ba;
    font-size: 14px;
    margin-left: 5px;
  }
`;

const NewsButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 7px;
  position: relative;
  border-top: 1px solid #e6e2e8;
  button {
    color: #e92070;
    font-size: 16px;
    font-family: 'cerapro';
    border: none;
    outline: none;
    background: transparent;
    padding: 10px;
    font-weight: 600;
    cursor: pointer;
  }
`;

const NewsHeader = styled.div`
  width: 100%;
  position: relative;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 99;
    opacity: 1;
    transition: opacity 1s ease;
    animation: skeleton-anim;
    animation-duration: 0.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
  div {
    position: relative;
    img {
      max-width: 100%;
    }
  }
`;

export {
  NewsItemStyled,
  NewsButtonContainer,
  NewsHeader,
  NewsBody,
  NewsBodyHeader,
  NewsBodyHeaderLeftContent,
  NewsBodyHeaderRightContent,
  NewsBodyContent,
};
